/* eslint-disable no-underscore-dangle */
import { addInitHook, override } from './measureUtils';

import { RADIUS, formatArea, formatDistance } from '@leaflet/utils';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

var circleArea = function circleArea(d) {
  var rho = d / RADIUS;
  return 2 * Math.PI * RADIUS * RADIUS * (1 - Math.cos(rho));
};

L.Circle.include({
  showMeasurements: function (options) {
    if (!this._map || this._measurementLayer) return this;

    this._measurementOptions = L.extend(
      {
        showOnHover: false,
        showArea: true,
        lang: {
          totalArea: 'Total area',
          radiusLength: 'Radius length',
        },
      },
      options || {}
    );

    this._measurementLayer = L.layerGroup().addTo(this._map);
    this.updateMeasurements();

    this._map.on('zoomend', this.updateMeasurements, this);

    return this;
  },

  hideMeasurements: function () {
    if (!this._map) return this;

    this._map.on('zoomend', this.updateMeasurements, this);

    if (!this._measurementLayer) return this;
    this._map.removeLayer(this._measurementLayer);
    this._measurementLayer = null;

    return this;
  },

  onAdd: override(L.Circle.prototype.onAdd, function (originalReturnValue) {
    this._areaUnit = 'm';
    this._distanceUnit = 'auto';

    var showOnHover =
      this.options.measurementOptions &&
      this.options.measurementOptions.showOnHover;
    if (this.options.showMeasurements && !showOnHover) {
      this.showMeasurements(this.options.measurementOptions);
    }

    return originalReturnValue;
  }),

  onRemove: override(
    L.Circle.prototype.onRemove,
    function (originalReturnValue) {
      this.hideMeasurements();

      return originalReturnValue;
    },
    true
  ),

  setLatLng: override(
    L.Circle.prototype.setLatLng,
    function (originalReturnValue) {
      this.updateMeasurements();

      return originalReturnValue;
    }
  ),

  setRadius: override(
    L.Circle.prototype.setRadius,
    function (originalReturnValue) {
      this.updateMeasurements();

      return originalReturnValue;
    }
  ),

  getAvailableDistanceUnits: function () {
    return ['m', 'km'];
  },
  setDistanceUnit: function (unit) {
    let availableUnits = this.getAvailableDistanceUnits();
    this._distanceUnit = availableUnits.includes(unit) ? unit : 'm';
    this.updateMeasurements();
  },
  getAvailableAreaUnits: function () {
    return ['auto', 'm', 'km', 'ha'];
  },
  setAreaUnit: function (unit) {
    let availableUnits = this.getAvailableAreaUnits();
    this._areaUnit = availableUnits.includes(unit) ? unit : 'm';
    this.updateMeasurements();
  },

  formatArea: formatArea,
  formatDistance: formatDistance,

  updateMeasurements: function (event = null) {
    // Captura a posição atual do mouse, para realizar as medições baseadas na posição do cursor
    let curLatLng;
    if (event?.type === 'mousemove') {
      curLatLng = event.latlng;
    }
    if (!this._measurementLayer) return;

    let latLng = this.getLatLng(),
      options = this._measurementOptions,
      formatterArea = options.formatArea || L.bind(this.formatArea, this),
      formatterDistance =
        options.formatDistance || L.bind(this.formatDistance, this);
    this._measurementLayer.clearLayers();

    if (latLng.lat !== 0 && latLng.lng !== 0) {
      if (options.showArea && !curLatLng) {
        var area = circleArea(this.getRadius());
        L.marker
          .measurement(
            latLng,
            formatterArea(area, this._areaUnit),
            options.lang.totalArea,
            0,
            options
          )
          .addTo(this._measurementLayer);
      } else if (curLatLng) {
        //Show radius length
        let p1 = this._map.latLngToLayerPoint(latLng),
          p2 = this._map.latLngToLayerPoint(curLatLng);
        var distance = latLng.distanceTo(curLatLng);
        L.marker
          .measurement(
            this._map.layerPointToLatLng([
              (p1.x + p2.x) / 2,
              (p1.y + p2.y) / 2,
            ]),
            formatterDistance(distance, this._distanceUnit),
            options.lang.radiusLength,
            0,
            options
          )
          .addTo(this._measurementLayer);
      }
    }
  },
});

L.Circle.addInitHook(function () {
  addInitHook.call(this);
});
